<template>
  <div class="footer">
    <div class="set-position" style="width: 100%;max-width: 1200px;margin: 0 auto;">
      <div class="pull-left">
        <div
          style="display:inline-block;vertical-align:top;    width: 100px;
    text-align: center;"
        >
          <img src="static/imgs/wechat.jpg" alt width="70px" />
          <p>友云采公众号</p>
        </div>
        <div
          style="display:inline-block;vertical-align:top;    width: 100px;
    text-align: center;"
        >
          <img src="static/imgs/supplier.png" alt width="70px" />
          <p>供应商App</p>
        </div>
        <div style="display:inline-block;    width: 100px;
    text-align: center;">
          <img src="static/imgs/purchaser.png" alt width="70px" />
          <p>采购商App</p>
        </div>
      </div>
      <div class="footer-right pull-right">
        <div id="footer-phone">
          <div>
            <img src="static/imgs/footer-phone.png" alt />
          </div>
        </div>
        <div>
          <p>联系电话：{{telephone}}</p>
          <p>服务时间：{{servicetime}}</p>
          <!--  <p>电子邮件：liucca@yonyou.com</p> -->
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { apiLinks } from 'src/api/links'
export default {
  data () {
    return {
      telephone: apiLinks.telephone,
      servicetime: apiLinks.servicetime
    }
  }
}
</script>
<style>
/*footer*/
.footer {
  color: #f5f5f5;
  /*background-color: #5c5c5c;*/
  background-color: #4b5a6d;
  margin-top: 80px;
  font-size: 14px;
  overflow: hidden;
  padding-top: 20px;
}

.footer a {
  color: #bbbbbb;
}

.footer-left {
  margin-top: 30px;
  margin-left: 10px;
}

.footer-right {
  /* margin-top: 20px; */
  margin-right: 10px;
}

.footer-left > div {
  display: inline-block;
}

.footer-right > div {
  display: inline-block;
}

#footer-logo {
  margin-right: 20px;
}

#footer-logo > div {
  width: 48px;
  height: 61px;
  overflow: hidden;
}

#footer-phone {
  margin-right: 20px;
}

#footer-phone > div img {
  position: relative;
  top: -17px;
}

#service-call {
  font-size: 20px;
}

.footer-right .name {
  margin-left: 75px;
}

.footer-right .call {
  font-size: 20px;
  margin-left: 10px;
}
</style>



// WEBPACK FOOTER //
// G-footer.vue?3a17ee36